/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var ActionKeyCodes;
    (function (ActionKeyCodes) {
        ActionKeyCodes["Enter"] = "Enter";
        ActionKeyCodes["ArrowUp"] = "ArrowUp";
        ActionKeyCodes["ArrowDown"] = "ArrowDown";
        ActionKeyCodes["Escape"] = "Escape";
        ActionKeyCodes["Tab"] = "Tab";
    })(ActionKeyCodes || (ActionKeyCodes = {}));
    MoyaComponents.register('parlogis.filter-radio', function (el) {
        var item = new ParlogisFilterRadio(el);
        item.run();
    });
    var ParlogisFilterRadio = /** @class */ (function () {
        function ParlogisFilterRadio(el) {
            this.el = el;
            this.options = el.querySelectorAll('div.option');
        }
        ParlogisFilterRadio.prototype.run = function () {
            this.createInputElement();
            this.bind();
        };
        ParlogisFilterRadio.prototype.createInputElement = function () {
            var input = document.createElement('input');
            input.classList.add('radioSearch');
            input.type = 'text';
            input.autocomplete = 'off';
            input.autocapitalize = 'off';
            input.spellcheck = false;
            input.placeholder = 'Leit í vöruflokki';
            input.setAttribute('aria-label', 'Filter');
            input.setAttribute('aria-expanded', 'true');
            input.setAttribute('aria-autocomplete', 'list');
            this.searchInput = input;
            this.el.parentElement.prepend(this.searchInput);
        };
        ParlogisFilterRadio.prototype.bind = function () {
            var _this = this;
            util.delegate(this.el.parentElement, 'keyup', '.radioSearch', function (e) {
                if (!(e instanceof KeyboardEvent)) {
                    return;
                }
                // Don't do searchInput when tab/arrow/enter was pressed
                if (Array.from(Object.values(ActionKeyCodes)).includes(e.key)) {
                    return;
                }
                _this.doSearch(e);
            });
        };
        ParlogisFilterRadio.prototype.doSearch = function (e) {
            var needle = this.searchInput.value.trim().toLowerCase();
            var isEmpty = needle === '';
            this.options.forEach(function (opt) {
                if (isEmpty) {
                    opt.style.removeProperty('display');
                    return;
                }
                var haystack = opt.textContent.trim().toLowerCase();
                if (haystack.includes(needle)) {
                    opt.style.removeProperty('display');
                }
                else {
                    opt.style.display = 'none';
                }
            });
        };
        return ParlogisFilterRadio;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
